var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 87,
    viewBox: "0 0 83 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_dd_1785_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7842 31.2L44.6946 24.34C42.7204 23.22 40.278 23.22 38.2834 24.34L26.2142 31.2C25.2409 31.7545 24.4332 32.551 23.8723 33.5094C23.3114 34.4678 23.0171 35.5544 23.0188 36.66V50.34C23.0188 52.58 24.24 54.66 26.2142 55.8L38.3038 62.66C40.278 63.78 42.7204 63.78 44.7149 62.66L56.8045 55.8C57.7778 55.2455 58.5855 54.449 59.1464 53.4906C59.7073 52.5322 60.0017 51.4456 59.9999 50.34V36.66C59.9911 35.5542 59.69 34.4695 59.1263 33.5124C58.5626 32.5553 57.7555 31.7584 56.7842 31.2ZM41.4992 34.18C44.1247 34.18 46.2414 36.26 46.2414 38.84C46.2414 41.42 44.1247 43.5 41.4992 43.5C38.8737 43.5 36.757 41.42 36.757 38.84C36.757 36.28 38.8737 34.18 41.4992 34.18ZM46.9537 52.82H36.0446C34.396 52.82 33.4395 51.02 34.3553 49.68C35.7393 47.66 38.4259 46.3 41.4992 46.3C44.5725 46.3 47.259 47.66 48.643 49.68C49.5589 51 48.582 52.82 46.9537 52.82Z",
    fill: "#ECFFEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1785_1534",
    x: 0.39023,
    y: 0.871431,
    width: 82.2383,
    height: 85.2571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.3143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.82 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1785_1534"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.93333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.521569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1785_1534",
    result: "effect2_dropShadow_1785_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1785_1534",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.c09ca4bb.svg";
export { ForwardRef as ReactComponent };